import { Editor, Node } from 'slate';
import { isElementType } from '.';
import { EjsButtonElement, EjsPlaceholderElement } from '../types';

// Is node an EJS button
export const isEjsButton = (node: Node): node is EjsButtonElement =>
	isElementType(node, 'ejs-button');

// Is node an EJS placeholder
export const isEjsPlaceholder = (node: Node): node is EjsPlaceholderElement =>
	isElementType(node, 'ejs-placeholder');

// Is node EJS
export const isEjs = (
	node: Node
): node is EjsButtonElement | EjsPlaceholderElement =>
	isEjsButton(node) || isEjsPlaceholder(node);

// Is node (within editor) EJS
export const isSelectionEjs = (editor: Editor): boolean => {
	if (!editor.selection) return false;

	const selectedElement = Node.descendant(
		editor,
		editor.selection.anchor.path.slice(0, -1)
	);

	return isEjs(selectedElement);
};
